import { getFullVariant } from '@wetransfer/transfer/modules/experiments';

enum FFPaidTransfersAlphaVariant {
  control = 'control',
  'enable-paid-transfers' = 'enable-paid-transfers',
}

export default class FFPaidTransfersAlpha {
  static key = 'paid-transfers-alpha';

  static variations = FFPaidTransfersAlphaVariant;

  static isControl(): boolean {
    return this.currentVariant() === this.variations.control;
  }

  static isEnablePaidTransfers(): boolean {
    return this.currentVariant() === this.variations['enable-paid-transfers'];
  }

  static currentVariant(): FFPaidTransfersAlphaVariant {
    return getFullVariant(this.key, { value: this.variations.control })
      .value as FFPaidTransfersAlphaVariant;
  }
}
